(function () {
  const EMPTY_BOX_ID = "#empty-search-container";

  const BOOST_INPUT_SELECTOR =
    'input[id^="boost-sd__search-widget-init-input"], input.boost-sd__search-widget-init-input, .search-modal input[type="search"], .search-modal__form input';

  const BOOST_DESKTOP_BOX = "#bc-instant-search";
  const BOOST_MOBILE_WRAPPER = "#boost-sd__search-bar-autocomplete-wrapper";
  const SEARCH_MODAL = ".search-modal";
  const SEARCH_MODAL_CONTENT = ".search-modal__content";
  const SEARCH_HISTORY_KEY = "skechers_search_history";
  const MAX_HISTORY_ITEMS = 5;

  let lastFocusedBoostInput = null;
  let handleTimeout = null;
  let isHandling = false;
  let justFocused = false;

  // ========== BOOST AI SEARCH PAGINATION ==========
  
  function initializeBoostSearchPagination() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            // Check for Boost search slider wrapper
            const sliderWrapper = node.querySelector?.('.boost-sd__product-slider-wrapper') || 
                                 (node.classList?.contains('boost-sd__product-slider-wrapper') ? node : null);
            
            if (sliderWrapper) {
              setupBoostSliderPagination(sliderWrapper);
            }
          }
        });
      });
    });

    // Start observing the document body for changes
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Also check for existing sliders
    document.querySelectorAll('.boost-sd__product-slider-wrapper').forEach(setupBoostSliderPagination);
  }

  function setupBoostSliderPagination(sliderWrapper) {
    // Skip if already initialized
    if (sliderWrapper.hasAttribute('data-pagination-initialized')) {
      return;
    }
    
    const productList = sliderWrapper.querySelector('.boost-sd__instant-search-product-list-items');
    const prevButton = sliderWrapper.querySelector('.boost-prev');
    const nextButton = sliderWrapper.querySelector('.boost-next');
    const paginationContainer = sliderWrapper.querySelector('.boost-sd__pagination');
    
    if (!productList || !prevButton || !nextButton || !paginationContainer) {
      return;
    }
    
    // Mark as initialized
    sliderWrapper.setAttribute('data-pagination-initialized', 'true');
    
    console.log('[BoostSearch] Setting up pagination for product slider');
    
    // Calculate items per page based on container width
    const getItemsPerPage = () => {
      const containerWidth = productList.offsetWidth;
      const firstItem = productList.querySelector('.boost-sd__suggestion-queries-item');
      if (!firstItem) return 1;
      
      const itemWidth = firstItem.offsetWidth;
      const gap = 12;
      return Math.floor(containerWidth / (itemWidth + gap)) || 1;
    };
    
    // Calculate total pages
    const getTotalPages = () => {
      const items = productList.querySelectorAll('.boost-sd__suggestion-queries-item');
      const itemsPerPage = getItemsPerPage();
      return Math.ceil(items.length / itemsPerPage);
    };
    
    // Get current page based on scroll position
    const getCurrentPage = () => {
      const scrollLeft = productList.scrollLeft;
      const itemWidth = productList.querySelector('.boost-sd__suggestion-queries-item')?.offsetWidth || 200;
      const gap = 12;
      const itemsPerPage = getItemsPerPage();
      
      const pageWidth = (itemWidth + gap) * itemsPerPage;
      return Math.round(scrollLeft / pageWidth) + 1;
    };
    
    // Create pagination dots
    const createPaginationDots = () => {
      const totalPages = getTotalPages();
      paginationContainer.innerHTML = '';
      
      for (let i = 1; i <= totalPages; i++) {
        const dot = document.createElement('button');
        dot.className = 'boost-sd__pagination-dot';
        dot.setAttribute('aria-label', `Go to page ${i}`);
        dot.setAttribute('data-page', i);
        dot.innerHTML = '';
        
        if (i === 1) {
          dot.classList.add('boost-sd__pagination-dot--active');
        }
        
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          goToPage(i);
        });
        
        paginationContainer.appendChild(dot);
      }
    };
    
    // Go to specific page
    const goToPage = (pageNum) => {
      const items = productList.querySelectorAll('.boost-sd__suggestion-queries-item');
      if (items.length === 0) return;
      
      const itemWidth = items[0].offsetWidth;
      const gap = 12;
      const itemsPerPage = getItemsPerPage();
      
      const targetScroll = (pageNum - 1) * (itemWidth + gap) * itemsPerPage;
      productList.scrollTo({ left: targetScroll, behavior: 'smooth' });
    };
    
    // Update pagination dots active state
    const updatePaginationDots = () => {
      const currentPage = getCurrentPage();
      const dots = paginationContainer.querySelectorAll('.boost-sd__pagination-dot');
      
      dots.forEach((dot, index) => {
        if (index + 1 === currentPage) {
          dot.classList.add('boost-sd__pagination-dot--active');
        } else {
          dot.classList.remove('boost-sd__pagination-dot--active');
        }
      });
    };
    
    // Update button states
    const updateButtons = () => {
      const scrollLeft = productList.scrollLeft;
      const maxScroll = productList.scrollWidth - productList.clientWidth;
      
      if (scrollLeft <= 0) {
        prevButton.setAttribute('disabled', 'disabled');
      } else {
        prevButton.removeAttribute('disabled');
      }
      
      if (scrollLeft >= maxScroll - 5) {
        nextButton.setAttribute('disabled', 'disabled');
      } else {
        nextButton.removeAttribute('disabled');
      }
      
      updatePaginationDots();
    };
    
    // Previous button click
    prevButton.addEventListener('click', (e) => {
      e.preventDefault();
      const itemsPerPage = getItemsPerPage();
      const itemWidth = productList.querySelector('.boost-sd__suggestion-queries-item')?.offsetWidth || 200;
      const gap = 12;
      const scrollAmount = (itemWidth + gap) * itemsPerPage;
      
      productList.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      setTimeout(updateButtons, 300);
    });
    
    // Next button click
    nextButton.addEventListener('click', (e) => {
      e.preventDefault();
      const itemsPerPage = getItemsPerPage();
      const itemWidth = productList.querySelector('.boost-sd__suggestion-queries-item')?.offsetWidth || 200;
      const gap = 12;
      const scrollAmount = (itemWidth + gap) * itemsPerPage;
      
      productList.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      setTimeout(updateButtons, 300);
    });
    
    // Update on scroll
    productList.addEventListener('scroll', updateButtons);
    
    // Handle window resize
    const handleResize = () => {
      createPaginationDots();
      updateButtons();
    };
    window.addEventListener('resize', handleResize);
    
    // Initial setup
    setTimeout(() => {
      createPaginationDots();
      updateButtons();
      console.log('[BoostSearch] Pagination initialized successfully');
    }, 100);
  }

  // Initialize Boost pagination when DOM is ready
  document.addEventListener('DOMContentLoaded', initializeBoostSearchPagination);

  // Also initialize immediately if DOM is already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeBoostSearchPagination);
  } else {
    initializeBoostSearchPagination();
  }

  // ========== SEARCH HISTORY FUNCTIONS ==========
  
  function getSearchHistory() {
    try {
      const history = localStorage.getItem(SEARCH_HISTORY_KEY);
      return history ? JSON.parse(history) : [];
    } catch (e) {
      console.error('[SearchHistory] Error reading history:', e);
      return [];
    }
  }

  function saveSearchQuery(query) {
    if (!query || query.trim().length < 2) {
      console.log('[SearchHistory] Query too short or empty:', query);
      return;
    }
    
    try {
      let history = getSearchHistory();
      const trimmedQuery = query.trim().toLowerCase();
      
      // Remove if already exists
      history = history.filter(item => item.toLowerCase() !== trimmedQuery);
      
      // Add to beginning
      history.unshift(trimmedQuery);
      
      // Keep only last MAX_HISTORY_ITEMS
      history = history.slice(0, MAX_HISTORY_ITEMS);
      
      localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(history));
      console.log('[SearchHistory] ✅ Saved:', trimmedQuery, 'Total history:', history);
    } catch (e) {
      console.error('[SearchHistory] ❌ Error saving:', e);
    }
  }
  
  // Expose function globally for testing
  window.saveSearchQuery = saveSearchQuery;
  window.getSearchHistory = getSearchHistory;

  function renderSearchHistory() {
    const historyContainer = document.querySelector('.empty-search-history-items');
    if (!historyContainer) return;
    
    const history = getSearchHistory();
    
    if (history.length === 0) {
      historyContainer.innerHTML = '<p style="color: rgba(var(--color-foreground), 0.6); font-size: 14px;">No recent searches</p>';
      return;
    }
    
    historyContainer.innerHTML = history.map(query => {
      const encodedQuery = encodeURIComponent(query);
      return `<a class="history-search-tag" href="/search?q=${encodedQuery}"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.5 5.00002V7.71689L10.7575 9.07127C10.8712 9.13956 10.9531 9.25023 10.9853 9.37893C11.0174 9.50762 10.997 9.64381 10.9288 9.75752C10.8605 9.87123 10.7498 9.95316 10.6211 9.98527C10.4924 10.0174 10.3562 9.99706 10.2425 9.92877L7.7425 8.42877C7.66851 8.38432 7.60729 8.32146 7.56479 8.24633C7.52229 8.17119 7.49997 8.08634 7.5 8.00002V5.00002C7.5 4.86741 7.55268 4.74023 7.64645 4.64647C7.74022 4.5527 7.86739 4.50002 8 4.50002C8.13261 4.50002 8.25979 4.5527 8.35355 4.64647C8.44732 4.74023 8.5 4.86741 8.5 5.00002ZM8 2.00002C7.21125 1.99805 6.42994 2.15254 5.70128 2.45454C4.97263 2.75653 4.31111 3.20004 3.755 3.75939C3.30063 4.21939 2.89688 4.66189 2.5 5.12502V4.00002C2.5 3.86741 2.44732 3.74023 2.35355 3.64647C2.25979 3.5527 2.13261 3.50002 2 3.50002C1.86739 3.50002 1.74021 3.5527 1.64645 3.64647C1.55268 3.74023 1.5 3.86741 1.5 4.00002V6.50002C1.5 6.63263 1.55268 6.7598 1.64645 6.85357C1.74021 6.94734 1.86739 7.00002 2 7.00002H4.5C4.63261 7.00002 4.75979 6.94734 4.85355 6.85357C4.94732 6.7598 5 6.63263 5 6.50002C5 6.36741 4.94732 6.24023 4.85355 6.14647C4.75979 6.0527 4.63261 6.00002 4.5 6.00002H3.0625C3.50938 5.47377 3.95438 4.97814 4.46188 4.46439C5.15678 3.76949 6.04107 3.29477 7.00423 3.09957C7.96739 2.90436 8.96673 2.99732 9.87736 3.36682C10.788 3.73633 11.5696 4.366 12.1244 5.17715C12.6792 5.9883 12.9827 6.94497 12.9969 7.92761C13.0111 8.91026 12.7354 9.8753 12.2043 10.7022C11.6732 11.529 10.9102 12.181 10.0106 12.5767C9.11103 12.9724 8.1148 13.0942 7.1464 12.927C6.17799 12.7597 5.28034 12.3108 4.56563 11.6363C4.51786 11.5911 4.46167 11.5558 4.40026 11.5324C4.33885 11.509 4.27343 11.4979 4.20773 11.4997C4.14204 11.5016 4.07735 11.5164 4.01736 11.5432C3.95738 11.5701 3.90327 11.6085 3.85813 11.6563C3.81298 11.704 3.77769 11.7602 3.75427 11.8216C3.73084 11.883 3.71974 11.9485 3.7216 12.0142C3.72345 12.0799 3.73823 12.1445 3.76509 12.2045C3.79195 12.2645 3.83036 12.3186 3.87813 12.3638C4.59028 13.0358 5.45609 13.5234 6.4 13.7838C7.34391 14.0443 8.33722 14.0698 9.29326 13.8581C10.2493 13.6464 11.139 13.204 11.8847 12.5694C12.6304 11.9347 13.2095 11.1273 13.5713 10.2174C13.9332 9.30753 14.0669 8.32293 13.9607 7.34951C13.8546 6.37609 13.5118 5.44345 12.9623 4.63298C12.4128 3.8225 11.6733 3.15883 10.8083 2.69988C9.94334 2.24093 8.97919 2.00066 8 2.00002Z" fill="currentColor"/>
</svg> ${query}</a>`;
    }).join('');
  }

  // ========== END SEARCH HISTORY FUNCTIONS ==========

  function removeDuplicateEmptySearch() {
  const all = document.querySelectorAll("#empty-search-container");
  if (all.length > 1) {
    // keep first, remove all extra
    all.forEach((el, index) => {
      if (index > 0) el.remove();
    });
  }
}
removeDuplicateEmptySearch();


  function debouncedHandle(delay = 50) {
    if (handleTimeout) clearTimeout(handleTimeout);
    handleTimeout = setTimeout(function() {
      if (isHandling) return;
      isHandling = true;
      handle();
      isHandling = false;
    }, delay);
  }

  function isElementVisible(el) {
    if (!el) return false;
    const style = window.getComputedStyle(el);
    if (style.display === "none" || style.visibility === "hidden") return false;
    if (style.opacity === "0") return false;
    const rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function isBoostInput(el) {
    return !!(el && el.matches && el.matches(BOOST_INPUT_SELECTOR));
  }

  function getVisibleBoostInputs() {
    const inputs = Array.from(document.querySelectorAll(BOOST_INPUT_SELECTOR));
    return inputs.filter((el) => isElementVisible(el));
  }

  function getActiveBoostInput() {
    // ✅ Prefer focused element (works for position:fixed inputs too)
    if (isBoostInput(document.activeElement)) return document.activeElement;

    // ✅ Prefer last focused Boost input if still in DOM
    if (lastFocusedBoostInput && document.contains(lastFocusedBoostInput)) return lastFocusedBoostInput;

    // ✅ Otherwise pick a visible one
    const visible = getVisibleBoostInputs();
    if (visible.length) return visible[0];

    // fallback
    const inputs = Array.from(document.querySelectorAll(BOOST_INPUT_SELECTOR));
    return inputs[0] || null;
  }

  function emptyBoxEl() {
    return document.querySelector(EMPTY_BOX_ID);
  }

  function boostDesktopBoxEl() {
    return document.querySelector(BOOST_DESKTOP_BOX);
  }

  function boostMobileWrapperEl() {
    return document.querySelector(BOOST_MOBILE_WRAPPER);
  }

  function searchModalEl() {
    return document.querySelector(SEARCH_MODAL);
  }

  function searchModalContentEl() {
    return document.querySelector(SEARCH_MODAL_CONTENT);
  }

  function isBoostSearchOpen() {
    const input = getActiveBoostInput();
    if (!input) return false;

    // ✅ If we just focused on a Boost input, treat as open (aria-expanded may not be updated yet)
    if (justFocused) return true;

    // ✅ Most reliable check for all layouts
    const expanded = input.getAttribute("aria-expanded");
    if (expanded === "true") return true;

    // ✅ If the input is focused, treat search as open (Boost may not update aria-expanded immediately)
    if (document.activeElement === input) return true;

    // ✅ fallback checks (prefer wrapper if present)
    const wrapper = boostMobileWrapperEl();
    if (isElementVisible(wrapper)) return true;

    const box = boostDesktopBoxEl();
    if (isElementVisible(box)) return true;

    // ✅ Check if search modal is open (tablet 1024px case)
    const modal = searchModalEl();
    if (modal && isElementVisible(modal)) {
      return true;
    }

    return false;
  }

  function moveEmptySearchIntoMobileWrapper() {
    const emptyBox = emptyBoxEl();
    if (!emptyBox) return;

    const wrapper = boostMobileWrapperEl();
    if (isElementVisible(wrapper) && !wrapper.querySelector("#empty-search-container")) {
      wrapper.prepend(emptyBox);
      return true;
    }

    // ✅ For tablet (1024px) - insert into search modal content
    const modal = searchModalEl();
    if (modal && isElementVisible(modal) && !modal.querySelector("#empty-search-container")) {
      // Try to find form inside modal
      const form = modal.querySelector("form");
      if (form) {
        form.insertAdjacentElement("afterend", emptyBox);
        return true;
      }
      // Fallback: append to modal content
      const modalContent = searchModalContentEl();
      if (modalContent) {
        modalContent.appendChild(emptyBox);
        return true;
      }
    }

    return false;
  }

  function clearFixedDropdownPositioning(emptyBox) {
    if (!emptyBox) return;
    emptyBox.style.position = "";
    emptyBox.style.top = "";
    emptyBox.style.left = "";
    emptyBox.style.bottom = "";
    emptyBox.style.width = "";
    emptyBox.style.maxWidth = "";
    emptyBox.style.maxHeight = "";
  }

  let modalPanelFollow = null;

  function positionEmptySearchUnderInput(emptyBox, input) {
    if (!emptyBox || !input) return;

    const rect = input.getBoundingClientRect();
    if (!rect || rect.width === 0 || rect.height === 0) return;

    if (emptyBox.parentElement !== document.body) {
      document.body.appendChild(emptyBox);
    }

    // Mobile search modal: start under the whole search bar row and fill the rest of the screen
    const modalBar = window.innerWidth < 750 ? input.closest(".search-modal__content") : null;
    const place = function () {
      const top = modalBar ? modalBar.getBoundingClientRect().bottom : rect.bottom;
      emptyBox.style.top = Math.round(top) + "px";
    };

    emptyBox.style.position = "fixed";
    emptyBox.style.left = "0";
    emptyBox.style.width = "100%";
    emptyBox.style.maxWidth = "100%";
    emptyBox.style.bottom = modalBar ? "0" : "";
    emptyBox.style.maxHeight = modalBar ? "none" : "";
    place();
    if (modalBar) {
      // The modal animates open, so measure again once it has settled
      setTimeout(place, 150);
      setTimeout(place, 450);
      // Keep the panel attached to the bar if the page moves underneath
      if (modalPanelFollow) window.removeEventListener("scroll", modalPanelFollow);
      modalPanelFollow = place;
      window.addEventListener("scroll", modalPanelFollow, { passive: true });
    }
  }

  // Mobile search modal: the panel starts right under the search bar
  function setModalPanelTop(emptyBox) {
    const bar = emptyBox.closest(".search-modal__content");
    if (!bar) return;
    const apply = function () {
      document.documentElement.style.setProperty("--ps-top", Math.round(bar.getBoundingClientRect().bottom) + "px");
    };
    apply();
    // The modal animates open, so measure again once it has settled
    setTimeout(apply, 150);
    setTimeout(apply, 450);
  }

  function showEmptySearch() {
    const emptyBox = emptyBoxEl();
    const boostDesktopBox = boostDesktopBoxEl();
    if (!emptyBox) return;

    moveEmptySearchIntoMobileWrapper();

    const activeInput = getActiveBoostInput();
    if (!activeInput) return;

    const isInsideWrapper = !!emptyBox.closest(BOOST_MOBILE_WRAPPER);
    const isInsideModal = !!emptyBox.closest(SEARCH_MODAL);

    if (isInsideWrapper || isInsideModal) {
      clearFixedDropdownPositioning(emptyBox);
      if (isInsideModal) setModalPanelTop(emptyBox);
    } else {
      positionEmptySearchUnderInput(emptyBox, activeInput);
    }

    emptyBox.classList.remove("hidden");
    emptyBox.style.display = "flex";
    emptyBox.style.zIndex = "999999999";

    // Render dynamic search history
    renderSearchHistory();

    // Initialize slider with manual scroll implementation
    setTimeout(() => {
      const productSlider = emptyBox.querySelector('#Slider-empty-search-products');
      const collectionSlider = emptyBox.querySelector('#Slider-empty-search-collections');
      const slider = productSlider || collectionSlider;
      const prevButton = emptyBox.querySelector('button[name="previous"]');
      const nextButton = emptyBox.querySelector('button[name="next"]');
      
      if (slider && prevButton && nextButton) {
        console.log('[EmptySearch] Setting up manual slider for:', slider.id);
        
        // Calculate scroll amount (width of one item + gap)
        const getScrollAmount = () => {
          const firstItem = slider.querySelector('.grid__item');
          if (!firstItem) return slider.clientWidth;
          const itemWidth = firstItem.offsetWidth;
          const gap = 16; // 1.6rem gap
          return itemWidth + gap;
        };

        // Calculate total pages for pagination
        const getTotalPages = () => {
          const items = slider.querySelectorAll('.grid__item');
          if (items.length === 0) return 1;
          
          const itemWidth = items[0].offsetWidth;
          const gap = 16;
          const visibleWidth = slider.clientWidth;
          const itemsPerPage = Math.floor(visibleWidth / (itemWidth + gap)) || 1;
          
          return Math.ceil(items.length / itemsPerPage);
        };

        // Get current page based on scroll position
        const getCurrentPage = () => {
          const scrollLeft = slider.scrollLeft;
          const itemWidth = slider.querySelector('.grid__item')?.offsetWidth || slider.clientWidth;
          const gap = 16;
          const itemsPerPage = Math.floor(slider.clientWidth / (itemWidth + gap)) || 1;
          
          return Math.round(scrollLeft / ((itemWidth + gap) * itemsPerPage)) + 1;
        };

        // Create pagination dots
        const createPaginationDots = () => {
          const totalPages = getTotalPages();
          const existingPagination = slider.parentElement.querySelector('.boost-sd__pagination');
          
          if (existingPagination) {
            existingPagination.innerHTML = '';
            
            for (let i = 1; i <= totalPages; i++) {
              const dot = document.createElement('button');
              dot.className = 'boost-sd__pagination-dot';
              dot.setAttribute('aria-label', `Go to page ${i}`);
              dot.setAttribute('data-page', i);
              
              if (i === 1) {
                dot.classList.add('boost-sd__pagination-dot--active');
              }
              
              dot.addEventListener('click', (e) => {
                e.preventDefault();
                goToPage(i);
              });
              
              existingPagination.appendChild(dot);
            }
          }
        };

        // Go to specific page
        const goToPage = (pageNum) => {
          const items = slider.querySelectorAll('.grid__item');
          if (items.length === 0) return;
          
          const itemWidth = items[0].offsetWidth;
          const gap = 16;
          const itemsPerPage = Math.floor(slider.clientWidth / (itemWidth + gap)) || 1;
          
          const targetScroll = (pageNum - 1) * (itemWidth + gap) * itemsPerPage;
          slider.scrollTo({ left: targetScroll, behavior: 'smooth' });
        };

        // Update pagination dots active state
        const updatePaginationDots = () => {
          const currentPage = getCurrentPage();
          const dots = slider.parentElement.querySelectorAll('.boost-sd__pagination-dot');
          
          dots.forEach((dot, index) => {
            if (index + 1 === currentPage) {
              dot.classList.add('boost-sd__pagination-dot--active');
            } else {
              dot.classList.remove('boost-sd__pagination-dot--active');
            }
          });
        };
        
        // Update button states
        const updateButtons = () => {
          const scrollLeft = slider.scrollLeft;
          const maxScroll = slider.scrollWidth - slider.clientWidth;
          
          if (scrollLeft <= 0) {
            prevButton.setAttribute('disabled', 'disabled');
          } else {
            prevButton.removeAttribute('disabled');
          }
          
          if (scrollLeft >= maxScroll - 5) {
            nextButton.setAttribute('disabled', 'disabled');
          } else {
            nextButton.removeAttribute('disabled');
          }

          // Update pagination dots
          updatePaginationDots();
        };
        
        // Previous button click
        prevButton.addEventListener('click', (e) => {
          e.preventDefault();
          const scrollAmount = getScrollAmount();
          slider.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
          setTimeout(updateButtons, 300);
        });
        
        // Next button click
        nextButton.addEventListener('click', (e) => {
          e.preventDefault();
          const scrollAmount = getScrollAmount();
          slider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
          setTimeout(updateButtons, 300);
        });
        
        // Update on scroll
        slider.addEventListener('scroll', updateButtons);

        // Handle window resize
        const handleResize = () => {
          createPaginationDots();
          updateButtons();
        };
        window.addEventListener('resize', handleResize);
        
        // Initial setup
        createPaginationDots();
        updateButtons();
        
        console.log('[EmptySearch] Manual slider with pagination initialized for:', slider.id);
      }

      // Initialize Boost AI Search product slider pagination
      const boostSliderWrapper = emptyBox.querySelector('.boost-sd__product-slider-wrapper');
      if (boostSliderWrapper) {
        initializeBoostSliderPagination(boostSliderWrapper);
      }
    }, 200);

    // hide desktop boost suggestions only if exists
    if (boostDesktopBox && window.innerWidth > 991) {
      boostDesktopBox.style.opacity = "0";
    }
  }

  function hideEmptySearch() {
    const emptyBox = emptyBoxEl();
    const boostDesktopBox = boostDesktopBoxEl();
    if (!emptyBox) return;

    emptyBox.classList.add("hidden");
    emptyBox.style.display = "none";
    if (modalPanelFollow) {
      window.removeEventListener("scroll", modalPanelFollow);
      modalPanelFollow = null;
    }

    if (boostDesktopBox) boostDesktopBox.style.opacity = "1";
  }

  // ========== BOOST AI SEARCH PRODUCT SLIDER PAGINATION ==========
  
  function initializeBoostSliderPagination(sliderWrapper) {
    const productList = sliderWrapper.querySelector('.boost-sd__instant-search-product-list-items');
    const prevButton = sliderWrapper.querySelector('.boost-prev');
    const nextButton = sliderWrapper.querySelector('.boost-next');
    const paginationContainer = sliderWrapper.querySelector('.boost-sd__pagination');
    
    if (!productList || !prevButton || !nextButton || !paginationContainer) {
      console.log('[BoostSlider] Missing required elements for pagination');
      return;
    }
    
    console.log('[BoostSlider] Initializing pagination for Boost AI Search product slider');
    
    // Calculate items per page based on container width
    const getItemsPerPage = () => {
      const containerWidth = productList.offsetWidth;
      const firstItem = productList.querySelector('.boost-sd__suggestion-queries-item');
      if (!firstItem) return 1;
      
      const itemWidth = firstItem.offsetWidth;
      const gap = 12; // Default gap between items
      return Math.floor(containerWidth / (itemWidth + gap)) || 1;
    };
    
    // Calculate total pages
    const getTotalPages = () => {
      const items = productList.querySelectorAll('.boost-sd__suggestion-queries-item');
      const itemsPerPage = getItemsPerPage();
      return Math.ceil(items.length / itemsPerPage);
    };
    
    // Get current page based on scroll position
    const getCurrentPage = () => {
      const scrollLeft = productList.scrollLeft;
      const itemWidth = productList.querySelector('.boost-sd__suggestion-queries-item')?.offsetWidth || 200;
      const gap = 12;
      const itemsPerPage = getItemsPerPage();
      
      const pageWidth = (itemWidth + gap) * itemsPerPage;
      return Math.round(scrollLeft / pageWidth) + 1;
    };
    
    // Create pagination dots
    const createPaginationDots = () => {
      const totalPages = getTotalPages();
      paginationContainer.innerHTML = '';
      
      for (let i = 1; i <= totalPages; i++) {
        const dot = document.createElement('button');
        dot.className = 'boost-sd__pagination-dot';
        dot.setAttribute('aria-label', `Go to page ${i}`);
        dot.setAttribute('data-page', i);
        dot.innerHTML = '';
        
        if (i === 1) {
          dot.classList.add('boost-sd__pagination-dot--active');
        }
        
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          goToPage(i);
        });
        
        paginationContainer.appendChild(dot);
      }
    };
    
    // Go to specific page
    const goToPage = (pageNum) => {
      const items = productList.querySelectorAll('.boost-sd__suggestion-queries-item');
      if (items.length === 0) return;
      
      const itemWidth = items[0].offsetWidth;
      const gap = 12;
      const itemsPerPage = getItemsPerPage();
      
      const targetScroll = (pageNum - 1) * (itemWidth + gap) * itemsPerPage;
      productList.scrollTo({ left: targetScroll, behavior: 'smooth' });
    };
    
    // Update pagination dots active state
    const updatePaginationDots = () => {
      const currentPage = getCurrentPage();
      const dots = paginationContainer.querySelectorAll('.boost-sd__pagination-dot');
      
      dots.forEach((dot, index) => {
        if (index + 1 === currentPage) {
          dot.classList.add('boost-sd__pagination-dot--active');
        } else {
          dot.classList.remove('boost-sd__pagination-dot--active');
        }
      });
    };
    
    // Update button states
    const updateButtons = () => {
      const scrollLeft = productList.scrollLeft;
      const maxScroll = productList.scrollWidth - productList.clientWidth;
      
      if (scrollLeft <= 0) {
        prevButton.setAttribute('disabled', 'disabled');
      } else {
        prevButton.removeAttribute('disabled');
      }
      
      if (scrollLeft >= maxScroll - 5) {
        nextButton.setAttribute('disabled', 'disabled');
      } else {
        nextButton.removeAttribute('disabled');
      }
      
      updatePaginationDots();
    };
    
    // Previous button click
    prevButton.addEventListener('click', (e) => {
      e.preventDefault();
      const itemsPerPage = getItemsPerPage();
      const itemWidth = productList.querySelector('.boost-sd__suggestion-queries-item')?.offsetWidth || 200;
      const gap = 12;
      const scrollAmount = (itemWidth + gap) * itemsPerPage;
      
      productList.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      setTimeout(updateButtons, 300);
    });
    
    // Next button click
    nextButton.addEventListener('click', (e) => {
      e.preventDefault();
      const itemsPerPage = getItemsPerPage();
      const itemWidth = productList.querySelector('.boost-sd__suggestion-queries-item')?.offsetWidth || 200;
      const gap = 12;
      const scrollAmount = (itemWidth + gap) * itemsPerPage;
      
      productList.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      setTimeout(updateButtons, 300);
    });
    
    // Update on scroll
    productList.addEventListener('scroll', updateButtons);
    
    // Handle window resize
    const handleResize = () => {
      createPaginationDots();
      updateButtons();
    };
    window.addEventListener('resize', handleResize);
    
    // Initial setup
    setTimeout(() => {
      createPaginationDots();
      updateButtons();
      console.log('[BoostSlider] Pagination initialized successfully');
    }, 100);
  }

  function handle() {
    const input = getActiveBoostInput();
    if (!input) return;

    // ✅ Only work if search is really open
    if (!isBoostSearchOpen()) {
      hideEmptySearch();
      return;
    }

    // ✅ Show empty search only when query empty
    if (input.value.trim() === "") {
      showEmptySearch();
    } else {
      hideEmptySearch();
    }
  }

  // Always hide on load
  document.addEventListener("DOMContentLoaded", function () {
    hideEmptySearch();
  });

  // Desktop search (Boost or native): the page behind the dropdown does not scroll while it is open.
  // Scroll input is blocked instead of hiding the overflow, so the scrollbar stays and nothing shifts.
  const SEARCH_INPUT_SELECTOR = BOOST_INPUT_SELECTOR + ', .search_input input[name="q"]';
  const SEARCH_AREA_SELECTOR = [
    SEARCH_INPUT_SELECTOR,
    EMPTY_BOX_ID,
    BOOST_DESKTOP_BOX,
    BOOST_MOBILE_WRAPPER,
    SEARCH_MODAL,
    ".predictive-search",
    "#boost-sd__search-widget-init-wrapper",
  ].join(", ");
  let searchScrollLocked = false;

  function setSearchScrollLock(locked) {
    searchScrollLocked = locked;
  }

  // True when something inside the dropdown can still scroll in the wheel direction
  function canScrollInside(target, deltaY) {
    for (let el = target; el && el !== document.body; el = el.parentElement) {
      const overflowY = window.getComputedStyle(el).overflowY;
      if ((overflowY === "auto" || overflowY === "scroll") && el.scrollHeight > el.clientHeight) {
        const atTop = el.scrollTop <= 0;
        const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 1;
        if ((deltaY < 0 && !atTop) || (deltaY > 0 && !atBottom)) return true;
      }
    }
    return false;
  }

  document.addEventListener(
    "wheel",
    function (e) {
      if (!searchScrollLocked) return;
      const insideSearch = e.target.closest && e.target.closest(SEARCH_AREA_SELECTOR);
      // Sideways scrolling (product carousels) is fine
      if (insideSearch && Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
      if (insideSearch && canScrollInside(e.target, e.deltaY)) return;
      e.preventDefault();
    },
    { passive: false }
  );

  document.addEventListener(
    "touchmove",
    function (e) {
      if (!searchScrollLocked) return;
      if (e.target.closest && e.target.closest(SEARCH_AREA_SELECTOR)) return;
      e.preventDefault();
    },
    { passive: false }
  );

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") setSearchScrollLock(false);
    if (!searchScrollLocked) return;
    const typing = e.target.matches && e.target.matches("input, textarea, select, [contenteditable]");
    if (!typing && [" ", "PageUp", "PageDown", "Home", "End", "ArrowUp", "ArrowDown"].includes(e.key)) e.preventDefault();
  });

  document.addEventListener("focusin", function (e) {
    if (e.target.matches && e.target.matches(SEARCH_INPUT_SELECTOR)) setSearchScrollLock(true);
  });

  // Mobile search modal: closing it (back arrow) or toggling it releases the lock
  document.addEventListener("click", function (e) {
    if (e.target.closest(".search-modal__close-button, .header__icon--search")) setSearchScrollLock(false);
  });

  document.addEventListener("mousedown", function (e) {
    if (!e.target.closest(SEARCH_AREA_SELECTOR)) setSearchScrollLock(false);
  });

  // Show on focus
  document.addEventListener("focusin", function (e) {
    if (isBoostInput(e.target)) {
      lastFocusedBoostInput = e.target;
      justFocused = true;
      handle();
      setTimeout(function() { justFocused = false; }, 200);
    }
    removeDuplicateEmptySearch();
  });

  // Also handle click on Boost inputs (backup for 1024px modal case)
  document.addEventListener("click", function (e) {
    if (isBoostInput(e.target)) {
      lastFocusedBoostInput = e.target;
      justFocused = true;
      handle();
      setTimeout(function() { justFocused = false; }, 200);
    }
  });

  // Show/hide on typing
  document.addEventListener("input", function (e) {
    if (isBoostInput(e.target)) {
      lastFocusedBoostInput = e.target;
      debouncedHandle(30);
    }
  });

  // Click outside hides
  document.addEventListener("mousedown", function (e) {
    const emptyBox = emptyBoxEl();
    const activeInput = getActiveBoostInput();
    const boostDesktopBox = boostDesktopBoxEl();
    const boostMobile = boostMobileWrapperEl();

    if (!emptyBox || !activeInput) return;

    const clickedInsideInput = e.target === activeInput;
    const clickedInsideEmpty = e.target.closest(EMPTY_BOX_ID);
    const clickedInsideBoostDesktop = boostDesktopBox && e.target.closest(BOOST_DESKTOP_BOX);
    const clickedInsideBoostMobile = boostMobile && e.target.closest(BOOST_MOBILE_WRAPPER);
    const clickedInsideSearchModal = e.target.closest(SEARCH_MODAL);

    if (!clickedInsideInput && !clickedInsideEmpty && !clickedInsideBoostDesktop && !clickedInsideBoostMobile && !clickedInsideSearchModal) {
      hideEmptySearch();
    }
  });

  // Removed MutationObserver - was causing blinking due to Boost AI constantly updating DOM
  // Empty search now relies on focusin/input events which are sufficient
})();

// ✅ Prevent Boost from closing search when clicking inside empty-search
document.addEventListener(
  "mousedown",
  function (e) {
    if (e.target.closest("#empty-search-container")) {
      e.stopPropagation();
    }
  },
  true
);

// ✅ Keep focus on Boost input
document.addEventListener(
  "click",
  function (e) {
    if (e.target.closest("#empty-search-container")) {
      const activeInput = getActiveBoostInput();
      if (activeInput) activeInput.focus();
    }
  },
  true
);

// ========== CAPTURE SEARCH QUERIES ==========

// Capture when user clicks on Boost search results (product links, view all, etc.)
document.addEventListener('click', function(e) {
  const boostResultLink = e.target.closest('#bc-instant-search a, .boost-sd__search-bar-autocomplete-wrapper a, #boost-sd__search-bar-autocomplete-wrapper a');
  if (boostResultLink) {
    console.log('[SearchHistory] Boost result clicked');
    const input = document.querySelector('input[id^="boost-sd__search-widget-init-input"], input.boost-sd__search-widget-init-input, .search-modal input[type="search"]');
    if (input && input.value.trim()) {
      console.log('[SearchHistory] Capturing from Boost click:', input.value.trim());
      saveSearchQuery(input.value.trim());
    }
  }
}, true); // Use capture phase

// Capture when user submits search form
document.addEventListener('submit', function(e) {
  const searchForm = e.target.closest('form[action*="/search"]');
  if (searchForm) {
    console.log('[SearchHistory] Form submitted');
    const input = searchForm.querySelector('input[type="search"], input[name="q"]');
    if (input && input.value.trim()) {
      console.log('[SearchHistory] Capturing from form:', input.value.trim());
      saveSearchQuery(input.value.trim());
    }
  }
});

// Capture when user presses Enter in search input
document.addEventListener('keydown', function(e) {
  if (e.key === 'Enter') {
    const searchInput = e.target.closest('input[id^="boost-sd__search-widget-init-input"], input.boost-sd__search-widget-init-input, .search-modal input[type="search"], input[name="q"]');
    if (searchInput && searchInput.value.trim()) {
      console.log('[SearchHistory] Enter pressed in search:', searchInput.value.trim());
      saveSearchQuery(searchInput.value.trim());
    }
  }
});

// Capture from URL on search results page
if (window.location.pathname.includes('/search')) {
  const urlParams = new URLSearchParams(window.location.search);
  const query = urlParams.get('q');
  if (query && query.trim()) {
    console.log('[SearchHistory] Capturing from URL:', query.trim());
    saveSearchQuery(query.trim());
  }
}

// Additional: Monitor for navigation to search results (for Boost instant search)
let lastCapturedQuery = '';
setInterval(function() {
  if (window.location.pathname.includes('/search')) {
    const urlParams = new URLSearchParams(window.location.search);
    const query = urlParams.get('q');
    if (query && query.trim() && query !== lastCapturedQuery) {
      console.log('[SearchHistory] Detected new search in URL:', query.trim());
      saveSearchQuery(query.trim());
      lastCapturedQuery = query;
    }
  }
}, 1000);


// fixed position 
(function () {
  function setEmptySearchTop() {
    if (window.innerWidth <= 990) return;
    const headerSection =
      document.querySelector('.shopify-section-header') ||
      document.querySelector('.header-wrapper') ||
      document.querySelector('.section-header') ||
      document.querySelector('header');
    const search = document.querySelector('#empty-search-container');
    if (!headerSection || !search) return;
    const rect = headerSection.getBoundingClientRect();
    search.style.top = rect.bottom + "px";
  }

  function runOnlyDesktop() {
    if (window.innerWidth > 990) {
      setEmptySearchTop();
    }
  }
  document.addEventListener("DOMContentLoaded", runOnlyDesktop);
  window.addEventListener("scroll", runOnlyDesktop);
  window.addEventListener("resize", runOnlyDesktop);
  const observer = new MutationObserver(() => {
    if (window.innerWidth > 990) {
      setEmptySearchTop();
    }
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true
  });
})();
